import { client } from "../client.ts";

export async function fetchWorkspaces() {
    const { data, error } = await client.GET("/bff/subscription/workspaces");

    if (error) {
        throw error;
    }

    return data;
}
